import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              漫画分类
            </h2>
            <p className="text-sm text-foreground-500 mt-2">八大分类，总有一款适合你</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <div className="text-center">
                  <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-400 mt-1">{cat.count.toLocaleString()} 部作品</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}